import { bannerApi } from 'entities/banner/model';
import { toast } from 'react-toastify';
import { HTTP_METHODS } from 'shared/consts';

const modifyBannersApi = bannerApi.injectEndpoints({
  endpoints: (builder) => ({
    createBanner: builder.mutation({
      query: (form) => ({
        url: '/news-pages/admin/banners',
        method: HTTP_METHODS.POST,
        body: form,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error) => {
        const error_message = 'Произошла ошибка при создании баннер';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно создали новый баннер', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Banners' }];
      },
    }),
    deleteBanner: builder.mutation({
      query: ({ id }) => ({
        url: `/news-pages/admin/banner/${id}`,
        method: HTTP_METHODS.DELETE,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error) => {
        const error_message = 'Произошла ошибка при удалении баннера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили баннер', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1500,
          });
        }
        return [{ type: 'Banners' }];
      },
    }),
    updateBanner: builder.mutation({
      query: ({ id, form }) => ({
        url: `/news-pages/admin/banner/${id}`,
        method: 'PUT',
        body: form,
        headers: {
          'content-type': 'application/json',
        },
      }),
      invalidatesTags: (result, error) => {
        const error_message = 'Произошла ошибка при обновлении баннера';
        if (error) {
          toast.error(error_message.toString(), {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно обновили баннера', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'BannerId' }];
      },
    }),
  }),
});

export const { useCreateBannerMutation, useUpdateBannerMutation, useDeleteBannerMutation } = modifyBannersApi;
